export { ResultComponent } from './result.component';
export { AdResultModule } from './result.module';
